(function () {
  function init() {
    document.querySelectorAll('.djlml a[href^="#"]').forEach(function (link) {
      if (link.dataset.djlmlBound) return;
      link.dataset.djlmlBound = 'true';
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    document.querySelectorAll('[data-djlml-sticky]').forEach(function (sticky) {
      if (sticky.dataset.djlmlBound) return;
      sticky.dataset.djlmlBound = 'true';
      var targetSelector = sticky.dataset.showAfter || '#choose-your-engine';
      var target = document.querySelector(targetSelector);
      var update = function () {
        if (!target || !document.documentElement.contains(sticky)) return;
        sticky.classList.toggle('is-visible', target.getBoundingClientRect().bottom <= 0);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
